module.exports = __webpack_public_path__ + "static/media/features6.a16ffc50.png";